import * as z from 'zod';

import { CompanyId, CompanyReportQueryId, CompanyReportQueryRevisionId, UserId } from './BrandedIds';
import { zodDateOrString } from './utils';

/** One immutable version of a saved query's SQL; editing appends rather than rewriting. */
export const CompanyReportQueryRevision = z.object({
  id: CompanyReportQueryRevisionId,
  companyReportQueryId: CompanyReportQueryId,
  version: z.number().int().positive(),
  sql: z.string(),
  /** Lake tables the SQL reads, resolved by Athena at save time; drives the freshness check. */
  inputTables: z.string().array(),
  createdByUserId: UserId,
  createdAt: zodDateOrString,
});
export type CompanyReportQueryRevision = z.infer<typeof CompanyReportQueryRevision>;

/** A named SQL query a company saves and reruns as a report. Shared company-wide, not personal. */
export const CompanyReportQuery = z.object({
  id: CompanyReportQueryId,
  companyId: CompanyId,
  name: z.string(),
  category: z.string(),
  description: z.string().optional(),
  currentRevision: CompanyReportQueryRevision,
  createdByUserId: UserId,
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
});
export type CompanyReportQuery = z.infer<typeof CompanyReportQuery>;
